'use strict';

module Patersons {

    export class FAQ {
        title: string;
        content: string;
    }

    export interface HelpScope {
        faqList: Array<FAQ>;
        hasData: boolean;
        userCompany: UserCompany;
    }

    export class HelpViewCtrl extends AbstractController {
        scope: Patersons.HelpScope;
        helpService: Patersons.HelpService
        navigationService: Patersons.NavigationService

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'helpService', 'navigationService', 'userCompanyService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, helpService, navigationService, userCompanyService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.scope = $scope;
            this.helpService = helpService;
            this.navigationService = navigationService;

            this.navigationService.deactivateAll();
            this.load();
            userCompanyService.getUserCompany().then((company) => {
                this.scope.userCompany = company;
            })
        }

        load() {
            
            this.helpService.getFAQs()
                .then((result) => {
                    if (result) {
                        this.scope.faqList = result.faqs;
                    }
                    this.scope.hasData = this.scope.faqList != null && this.scope.faqList.length > 0;
                    this.log.info("Loaded Help List");
                }, (error) =>{ // error handling
                    this.scope.hasData = false;
                });
        }
    }
}
